const condo_sec1_part1Object = payload => {
  return {
    type: "condosec1part1",
    payload
  };
};

export default condo_sec1_part1Object;
